import React from "react";
import "./SummaryModal.css"; // renamed for clarity

const SummaryModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;

  const user = data.user || {};
  const product = data.selectedProduct || {};
  const reason = data.reason || "-";
  const processType = data.processType || "-";

  return (
    <div className="summaryModal__overlay">
      <div className="summaryModal__container">
        <h3 className="summaryModal__title">Ürün Atama Özeti</h3>

        <div className="summaryModal__content">
          <div className="summaryModal__row">
            <span className="label">Kullanıcı Adı:</span>
            <span className="value">{user.NameAndSurname || "-"}</span>
          </div>
          <div className="summaryModal__row">
            <span className="label">User ID:</span>
            <span className="value">{user.UserId || "-"}</span>
          </div>
          <div className="summaryModal__row">
            <span className="label">Nickname:</span>
            <span className="value">{user.Nickname || "-"}</span>
          </div>
          <div className="summaryModal__row">
            <span className="label">E-posta:</span>
            <span className="value">{user.Email || "-"}</span>
          </div>
          <div className="summaryModal__row">
            <span className="label">Telefon:</span>
            <span className="value">{user.PhoneNumber || "-"}</span>
          </div>
          <div className="summaryModal__row">
            <span className="label">Ürün:</span>
            <span className="value">{product.ProductName || "-"}</span>
          </div>
          <div className="summaryModal__row">
            <span className="label">İşlem Türü:</span>
            <span className="value">
              {processType === "error" ? "Satın Alma Hatası" : "Telefon Satışı"}
            </span>
          </div>
          <div className="summaryModal__row">
            <span className="label">Atama Nedeni:</span>
            <span className="value">{reason || "-"}</span>
          </div>

          <button
            className="summaryModal__closeBtn"
            onClick={onClose}
          >
            Tamam
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryModal;
